import * as Sentry from "@sentry/react"
import { createRoot } from "react-dom/client"
import App from "./App"

import "./index.css"

Sentry.init({
  dsn: "https://ec068d5cba6566a9a3dcaaccb0a2eacb@o4511310802124800.ingest.us.sentry.io/4511310803369984",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? "1.0"),
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/hwftdnrfagtshtdyueqj\.supabase\.co\//,
  ],
  environment: import.meta.env.MODE,
})

createRoot(document.getElementById("root")!).render(
  <App />,
)
